import Cookies from 'js-cookie'
// import Mgr from '../services/SecurityService'
let Mgr = null
let mgr = null

const LOGIN_MODE = window.SERVERAPI.LOGIN_MODE
const TokenKey = 'FN_TOKEN'

async function main() {
  Mgr = require('../services/SecurityService')
  Mgr = Mgr.default
  mgr = new Mgr()
}

if (LOGIN_MODE !== 'FANEWS') {
  main()
}

export function signOut() {
  if (LOGIN_MODE !== 'FANEWS') {
    mgr.signOut()
  }
}
export function getModel() {
  return new Promise((resolve, reject) => {
    if (LOGIN_MODE === 'FANEWS') {
      resolve({
        model: true
      })
    } else {
      resolve({
        model: false,
        mgr
      })
    }
  })
}
export function getToken(key = TokenKey) {
  return Cookies.get(key)
}

export function syncGetToken(key = TokenKey) {
  return new Promise((resolve, reject) => {
    if (LOGIN_MODE === 'FANEWS') {
      resolve({
        token: getToken(key),
        model: true
      })
    } else {
      mgr.getAcessToken().then(token => {
        resolve({
          token: token,
          model: false
        })
      })
    }
  })
}

export function setToken(token, params, key = TokenKey) {
  return Cookies.set(key, token, params)
}

export function removeToken(params, key = TokenKey) {
  return Cookies.remove(key, params)
}
